<mpro-loading *ngIf="loadingCitiyAgeGender || (dataService.getIsLoading() | async)"></mpro-loading>
<div class="row">
  <div class="col-9">
    <span class="header">Age & Gender Composition</span>
    <p class="sub-header">{{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}</p>
    <mpro-tags style="margin-bottom: 14px;" [age]="false" [gender]="false"></mpro-tags>
    <!-- tags -->
  </div>
  <div class="col-3" style="padding-left: 0;" *ngIf="doughnutData.length">
    <div class="doughnut-label female">{{ doughnutData[1].value | formatNumber }}% Female</div>
    <div class="doughnut-label male">{{ doughnutData[0].value | formatNumber }}% Male</div>
    <mpro-doughnut-chart [data]="doughnutData" [selectedSegment]="dataFilters.gender"></mpro-doughnut-chart>
  </div>
</div>

<mpro-grouped-bar-chart style="width: 100%; height: 400px; display:block; margin-top: 14px;" *ngIf="chartData.length"
  [options]="groupedChartOptions" [data]="chartData"></mpro-grouped-bar-chart>
<hr>

<mpro-accordion
  title="Age & Gender Breakdown"
  [primary]="false"
  labelSize="14px">
  <mpro-tags style="margin-top: 16px;" [spending]="false"></mpro-tags>
  <mpro-info-box [left]="femaleLeft" [right]="femaleRight" color="#A84680"
    [selected]="dataFilters.gender === 'female'" [fade]="dataFilters.gender === 'male'"></mpro-info-box>
  <mpro-info-box [left]="maleLeft" [right]="maleRight" color="#458461"
    [selected]="dataFilters.gender === 'male'" [fade]="dataFilters.gender === 'female'"></mpro-info-box>
  <mpro-info-box [left]="totalLeft" [right]="totalRight" color="#454545"
    [fade]="dataFilters.gender !== undefined"></mpro-info-box>
</mpro-accordion>
